import { Button } from "@/components/ui/button/button";
import { BreakList } from "@/components/break/break-list";
import { formatDuration } from "@/components/break/format";
import type { DaySummary } from "@/components/break/types";
import { formatTimeToIST } from "@/utils/timezone";

/** Shown after the check-out request succeeded; Done completes the logout. */
export const CheckoutSummary = ({
  summary,
  onDone,
}: {
  summary: DaySummary;
  onDone: () => void;
}) => (
  <div className="flex flex-col gap-4 text-left" data-testid="checkout-summary">
    <div>
      <h3 className="text-lg font-semibold">You are checked out for today</h3>
      <p className="text-sm text-muted-foreground">Here is your day at a glance.</p>
    </div>

    <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
      <div className="text-muted-foreground">Checked in at</div>
      <div className="font-medium" data-testid="summary-checkin-time">
        {summary.checkinAt ? formatTimeToIST(summary.checkinAt) : "—"}
      </div>
      <div className="text-muted-foreground">Checked out at</div>
      <div className="font-medium" data-testid="summary-checkout-time">
        {summary.checkoutAt ? formatTimeToIST(summary.checkoutAt) : "—"}
      </div>
      <div className="text-muted-foreground">Total break time</div>
      <div className="font-medium" data-testid="summary-total-break">
        {formatDuration(summary.totalBreakSeconds)} ({summary.breakCount}{" "}
        {summary.breakCount === 1 ? "break" : "breaks"})
      </div>
      <div className="text-muted-foreground">Total time (check-in to check-out)</div>
      <div className="font-medium" data-testid="summary-total-time">
        {formatDuration(summary.totalSeconds)}
      </div>
    </div>

    <div>
      <div className="text-xs uppercase tracking-wide text-muted-foreground mb-1">Breaks</div>
      <BreakList breaks={summary.breaks} emptyText="No breaks today." />
    </div>

    <p className="text-xs text-muted-foreground">
      Break time is recorded for reference only; it is not deducted from your working hours.
    </p>

    <div className="flex justify-end">
      <Button type="button" onClick={onDone} data-testid="checkout-done-button">
        Done
      </Button>
    </div>
  </div>
);
